import React, { useState, useMemo } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { DateGroupStyled } from "./styled";
import moment from "moment";
import { Inputs } from "components";

const DateGroup = ({
  theme_standard,
  initialValues,
  iconSvgClose,
  iconSvgOpen,
  options,
  placeholder,
  onChange,
  onChangeCustom,
  ...props
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const [_level1Value, _setLevel1Value] = useState();
  const [_level2Value, _setLevel2Value] = useState();
  const [_renderFilter, _setRenderFilter] = useState();

  const _onChangeFilterLevel1 = (key, value2) => {
    switch (key) {
      case "all":
        _setRenderFilter(false);
        onChange(`period=${key}`);
        break;
      case "day":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment().format(
            "YYYY-MM-DD"
          )}&end_date=${moment().format("YYYY-MM-DD")}`
        );
        break;
      case "quarter":
        const yearCurrent = moment().format("YYYY");
        _setRenderFilter(
          <Inputs.Dropdown
            options={[
              {
                label: "1. Apr - Jun",
                value: `start_date=${`${yearCurrent}-04-01`}&end_date=${yearCurrent}-06-30`,
              },
              {
                label: "2. Jul - Sep",
                value: `start_date=${`${yearCurrent}-07-01`}&end_date=${yearCurrent}-09-30`,
              },
              {
                label: "3. Oct - Dec",
                value: `start_date=${`${yearCurrent}-10-01`}&end_date=${yearCurrent}-12-31`,
              },
              {
                label: "4. Jan - Mar",
                value: `start_date=${`${yearCurrent + 1}-01-01`}&end_date=${
                  Number(yearCurrent) + 1
                }-03-31`,
              },
            ]}
            {...props}
            value={value2}
            arrowClosed={
              <span className="arrow_icon arrow-closed">{iconSvgClose}</span>
            }
            arrowOpen={
              <span className="arrow_icon arrow-open">{iconSvgOpen}</span>
            }
            placeholder={placeholder}
            onChange={(e) => {
              onChange(`period=${key}&${e}`);
              _setLevel2Value(e);
            }}
          />
        );
        break;
      case "date_range":
        _setRenderFilter(
          <Inputs.InputDatePickerBetween
            value={_level2Value}
            startDatePlaceholder="เริ่ม"
            endDatePlaceholder={"สิ้นสุด"}
            onChange={(e) => {
              onChange(
                `period=${key}&start_date=${moment(e.startDate).format(
                  "YYYY-MM-DD"
                )}&end_date=${moment(e.endDate).format("YYYY-MM-DD")}`
              );
            }}
          />
        );
        break;
      case "month":
        _setRenderFilter(
          <Inputs.DateTime
            startDatePlaceholder="เริ่ม"
            endDatePlaceholder={"สิ้นสุด"}
            showMonthYearPicker
            dateFormat="MM/yyyy"
            value={value2}
            onChange={(e) => {
              _setLevel2Value(e);
              onChange(
                `period=${key}&start_date=${moment(e)
                  .startOf("month")
                  .format("YYYY-MM-DD")}&end_date=${moment(e)
                  .endOf("month")
                  .format("YYYY-MM-DD")}`
              );
            }}
          />
        );
        break;
      case "year":
        _setRenderFilter(
          <Inputs.DateTime
            theme_standard
            startDatePlaceholder="เริ่ม"
            endDatePlaceholder={"สิ้นสุด"}
            showYearPicker
            dateFormat="yyyy"
            value={value2}
            onChange={(e) => {
              _setLevel2Value(e);
              onChange(
                `period=${key}&start_date=${moment(e)
                  .startOf("year")
                  .format("YYYY-MM-DD")}&end_date=${moment(e)
                  .endOf("year")
                  .format("YYYY-MM-DD")}`
              );
            }}
          />
        );
        break;
      case "today":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment()
            .startOf("day")
            .format("YYYY-MM-DD")}&end_date=${moment()
            .endOf("day")
            .format("YYYY-MM-DD")}`
        );
        break;
      case "this_week":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment()
            .startOf("week")
            .format("YYYY-MM-DD")}&end_date=${moment()
            .endOf("week")
            .format("YYYY-MM-DD")}`
        );
        break;
      case "last_7_days":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD")}&end_date=${moment().format("YYYY-MM-DD")}`
        );
        break;
      case "this_month":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment()
            .startOf("month")
            .format("YYYY-MM-DD")}&end_date=${moment()
            .endOf("month")
            .format("YYYY-MM-DD")}`
        );
        break;
      case "next_month":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment()
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD")}&end_date=${moment()
            .add(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD")}`
        );
        break;
      case "last_month":
        _setRenderFilter(false);
        onChange(
          `period=${key}&start_date=${moment()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD")}&end_date=${moment()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD")}`
        );
        break;
      default:
        break;
    }
  };

  useMemo(() => {
    if (initialValues) {
      console.log('initialValues', initialValues);
      _setLevel1Value(initialValues.level1);
      if (initialValues.level2) {
        _setLevel2Value(initialValues.level2);
        _onChangeFilterLevel1(initialValues.level1, initialValues.level2);
      }
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <DateGroupStyled>
      <div className={customClass}>
        <div className="date_group_wrap">
          <div className="dg_input_wrap">
            <Inputs.Dropdown
              {...props}
              options={options}
              placeholder={placeholder}
              value={_level1Value}
              onChange={(e) => {
                _setLevel1Value(e);
                _onChangeFilterLevel1(e);
              }}
            />
          </div>
          {_renderFilter}
        </div>
      </div>
    </DateGroupStyled>
  );
};

DateGroup.propTypes = {};

export default DateGroup;
